import type { ProductTypeConfig } from '@/types/product'

export const PRODUCT_TYPES: ProductTypeConfig[] = [
  {
    type_id: 1,
    type_label: 'Pasar Uang',
    background: 'var(--green-700)',
    descriptionLines: [
      'Risiko rendah, potensi imbal hasil rendah, pergerakan harga stabil, cocok',
      'untuk jangka waktu investasi <= 1 tahun'
    ]
  },
  {
    type_id: 2,
    type_label: 'Pendapatan Tetap',
    background: 'var(--navy-700)',
    descriptionLines: [
      'Risiko moderat, potensi imbal hasil menengah, pergerakan sedikit fluktuatif,',
      'cocok untuk jangka waktu investasi 1-3 tahun'
    ]
  },
  {
    type_id: 4,
    type_label: 'Campuran',
    background: 'var(--violet-700)',
    descriptionLines: [
      'Risiko dan potensi imbal hasil moderat tinggi, pergerakan harga fluktuatif,',
      'cocok untuk jangka menengah hingga panjang (3-5 tahun)'
    ]
  },
  {
    type_id: 3,
    type_label: 'Saham',
    background: 'var(--yellow-700)',
    descriptionLines: [
      'Risiko tinggi, potensi imbal hasil tinggi, pergerakan harga fluktuatif, cocok',
      'untuk jangka waktu investasi >= 5 tahun'
    ]
  },
  {
    type_id: 6,
    type_label: 'Indeks',
    background: 'var(--teal-700)',
    descriptionLines: [
      'Risiko dan potensi imbal hasil setara pasar, pergerakan harga fluktuatif,',
      'cocok untuk jangka waktu investasi >= 5 tahun'
    ]
  },
  {
    type_id: 7,
    type_label: 'Reksa Dana Terproteksi'
  },
  {
    type_id: null,
    type_label: 'Semua'
  }
]

export const GOLD_TREASURY_CODE = 'EMASTREASURY'
export const GOLD_PEGADAIAN_CODE = 'EMASPEGADAIAN'
export const GOLD_INDOGOLD_CODE = 'EMASINDOGOLD'

export const PRODUCT_TREASURY = {
  code: GOLD_TREASURY_CODE,
  name: 'Treasury',
  type: 'Asset Defensif',
  im_name: 'Government Treasury',
  logo: `${process.env.REACT_APP_STORAGE}/logo/partnership/treasury-new@512.png`
}

export const GOLD_OPERATIONAL_START_HOUR = 8
export const GOLD_OPERATIONAL_END_HOUR = 17

export const GOLD_PRODUCT = {
  [GOLD_TREASURY_CODE]: {
    product_name: 'Treasury'
  },
  [GOLD_PEGADAIAN_CODE]: {
    product_name: 'Pegadaian'
  },
  [GOLD_INDOGOLD_CODE]: {
    product_name: 'IndoGold'
  }
}
